"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["NotConfirmed"] = "NOT_CONFIRMED";
    OrderStatus["Confirmed"] = "CONFIRMED";
    OrderStatus["Cancelled"] = "CANCELLED";
    OrderStatus["Completed"] = "COMPLETED";
    OrderStatus["OnHold"] = "ON_HOLD";
    OrderStatus["Failed"] = "FAILED";
    OrderStatus["Expired"] = "EXPIRED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
